export default __webpack_public_path__ + "static/media/jardins.949f724a.png";